/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import { storyblokEditable } from '@storyblok/react/rsc'
import React from 'react'
import { ManualExpandableContentCard } from '@/components/dashboard/manuals/ui/ManualExpandableContentCard'
import { ManualBlok } from '@/components/storyblok/manual-bloks'
import { ExpandableContentStoryblok } from '@/lib/storyblok/types/generated-types'

/** A description of the available properties for this component. */
type ExpandableManualContentProps = {
  /** The Storyblok blok that represents this component. */
  blok: ExpandableContentStoryblok
}

/**
 * A simple expandable content component. This component will render a title and content that is hidden until the user
 * clicks on the title to expand it.
 */
const ExpandableManualContent: React.FC<ExpandableManualContentProps> = ({ blok }) => {
  const { title, content, heading_tag } = blok

  return (
    <ManualExpandableContentCard
      containerId={blok._uid}
      title={title}
      headingTag={heading_tag || undefined}
      content={
        <>
          {content.map((nestedBlok) => (
            // Children resolve via the manual override map so nested swapped bloks (typography, images, further
            // expandables) keep their manual variants — see manual-bloks.tsx.
            <ManualBlok blok={nestedBlok} key={nestedBlok._uid} {...storyblokEditable(nestedBlok)} />
          ))}
        </>
      }
      defaultOpen={true}
      {...storyblokEditable(blok)}
    />
  )
}

export { ExpandableManualContent }
